import { cn } from '../../lib/cn';

type Props = {
  device?: string;
  syncedFields?: string[];
  className?: string;
};

export function ContinuityBanner({
  device = 'Desktop',
  syncedFields = ['Context', 'Filters', 'AI Conversation'],
  className,
}: Props) {
  return (
    <div
      className={cn(
        'rounded-lg border border-info-200 bg-info-50 px-4 py-2 text-sm text-info-800 dark:border-info-900 dark:bg-info-950 dark:text-info-200',
        className,
      )}
      role="status"
    >
      <span className="font-medium">Continuity active</span>
      <span className="text-info-600 dark:text-info-400"> — synced to {device}: </span>
      <span className="text-xs">{syncedFields.join(' · ')}</span>
    </div>
  );
}
